<template>
  <div class="flex items-start gap-2.5">
    <img src="/orders/warn.svg" class="pt-1" />
    <p class="font-helvetica-400 font-normal text-[16px] text-extra-text-color">
      <slot />
    </p>
  </div>
</template>
